import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import classNames from 'classnames'

import { MainButton, BaseButton } from 'components/button'

import styles from './overlay.scss'

class Overlay extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='content'>
					<div styleName='thumbnail'>
						{this.props.videoIcon &&
							<iframe styleName='thumbnail-content' width='535' height='302' src={this.props.videoIcon} frameBorder='0' allow='encrypted-media' allowFullScreen></iframe>
						}
						{this.props.imgIcon &&
							<Isvg styleName='thumbnail-content' src={this.props.imgIcon} cacheGetRequests={true} />
						}
						{this.props.ctIcon &&
							<img styleName='thumbnail-content' src={this.props.ctIcon} />
						}
					</div>
					<div styleName='description'>
						<h1 styleName='description-title'>{this.props.offerTitle}</h1>
						<p styleName='description-message'>{this.props.offerMessage}</p>
						<div styleName={classNames({
							'description-button': true,
							'description-buttons': !!this.props.buttonTwo.text,
						})}
						>
							{this.props.buttonTwo.text &&
								<div styleName='button'><BaseButton pill={true} size='big' onClick={this.props.buttonTwo.action} bgColor='fullWhite'>{this.props.buttonTwo.text}</BaseButton></div>
							}
							<div styleName='button'><MainButton pill={true} size='big' onClick={this.props.buttonOne.action}>{this.props.buttonOne.text}</MainButton></div>
						</div>
						{this.props.buttonDismiss.text &&
							<a styleName="description-dismiss" href="#" onClick={this.props.buttonDismiss.action}>{this.props.buttonDismiss.text}</a>
						}
					</div>
				</div>
			</div>
		)
	}
}

Overlay.propTypes = {
	offerTitle: PropTypes.string,
	offerMessage: PropTypes.string,
	buttonOne: PropTypes.object.isRequired,
	buttonTwo: PropTypes.object,
	buttonDismiss: PropTypes.object,
	imgIcon: PropTypes.string,
	videoIcon: PropTypes.string,
}

Overlay.defaultProps = {
	offerTitle: '',
	offerMessage: '',
	buttonTwo: {},
	buttonDismiss: {},
	imgIcon: '',
	videoIcon: '',
}

export default CSSModules(Overlay, styles, {allowMultiple: true})

export {Overlay}
